import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
// import Drag from '../../campaign/dragNdDropKycFile';
import Drag from "./dragNdDrop";
import { putServerDataWithPath } from "../../../action/common_action";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";

import { ANY_ERROR } from "../../../action/user_action_types";
import http from "../../../util/http";
import { endPoints, url } from "../../../config";
import { axiosInstnace, getAdminData } from "../../../util/util";
class LinkPayment extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      contract_file: null,
      paymentId: null,
      error_msg: "",
      admininfo: getAdminData()
    };
  }

  uploadContractFile = async (e) => {
    e.preventDefault();
    console.log("Uploading contract");
    let { campaignId } = this.props;
    let status = await axiosInstnace.put(endPoints.linkpaymentId, {
      paymentId: this.state.paymentId,
      campainId: campaignId,
      email: this.state.admininfo.email
    });
    if (status.data.status === 400) {
      toast.error("Please Provide a valid Payment Id", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: false,
        toastId: "1",
        autoClose: false,
      });
    } else if (status.data.status === 404) {
      toast.error(status.data.message, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: false,
        toastId: "1",
        autoClose: false,
      });
    } else {
      this.props.callCurrentPage()
      this.props.closeAction()
    }
  };

  render() {
    let { contract_file, campaignData } = this.state;
    return (
      <div>
        <div className="modal-overlay">
          <div
            className="modal-wrapper thankyou-popup"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={this.props.closeAction}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <h4 className="popup-head rqst-head fct-head modal-title">
                    Update Payment Id
                  </h4>
                </div>
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">
                          <div className="lenght_file_wrapper">
                            <div className="flie_audio">
                              <div className="search_camp">
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    this.setState({
                                      paymentId: e.target.value,
                                    });
                                  }}
                                  value={this.state.paymentId}
                                  placeholder="Enter Valid razor Pay Id"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="create-camp nonfct-submit">
                          <button onClick={this.uploadContractFile}>
                            Update
                          </button>
                        </div>
                        <ToastContainer />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    updateContractToCampaign: (url, data, path) =>
      dispatch(putServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(LinkPayment);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/LinkPayment.js